export class CreateCostOffsetCodeError extends Error {
  constructor(
    message: string = 'Failed to create cost offset code',
    options?: { cause?: unknown }
  ) {
    super(message, options);
    this.name = 'CreateCostOffsetCodeError';
  }
}
